/**
 * @see https://stackoverflow.com/questions/9073150/converting-roman-numerals-to-decimal
 */
export const romanToArabic = (roman: string) => {
    if (roman === '') return 0;
    if (roman.startsWith('M')) return 1000 + romanToArabic(roman.substr(1));
    if (roman.startsWith('CM')) return 900 + romanToArabic(roman.substr(2));
    if (roman.startsWith('D')) return 500 + romanToArabic(roman.substr(1));
    if (roman.startsWith('CD')) return 400 + romanToArabic(roman.substr(2));
    if (roman.startsWith('C')) return 100 + romanToArabic(roman.substr(1));
    if (roman.startsWith('XC')) return 90 + romanToArabic(roman.substr(2));
    if (roman.startsWith('L')) return 50 + romanToArabic(roman.substr(1));
    if (roman.startsWith('XL')) return 40 + romanToArabic(roman.substr(2));
    if (roman.startsWith('X')) return 10 + romanToArabic(roman.substr(1));
    if (roman.startsWith('IX')) return 9 + romanToArabic(roman.substr(2));
    if (roman.startsWith('V')) return 5 + romanToArabic(roman.substr(1));
    if (roman.startsWith('IV')) return 4 + romanToArabic(roman.substr(2));
    if (roman.startsWith('I')) return 1 + romanToArabic(roman.substr(1));

    return Infinity;
};

export const romanToArabSortAsc = (a: string, b: string) => {
    let dec_a = romanToArabic(a);
    let dec_b = romanToArabic(b);

    return dec_a - dec_b;
};
